import { render, staticRenderFns } from "./BootheventAdd.vue?vue&type=template&id=b8ad8796&"
import script from "./BootheventAdd.vue?vue&type=script&lang=js&"
export * from "./BootheventAdd.vue?vue&type=script&lang=js&"
import style0 from "./BootheventAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports